module.exports = __webpack_public_path__ + "static/media/logo.0aa89158.png";